// @flow
import React from 'react';
import { toastr } from 'react-redux-toastr';
import Select from 'react-select';
import styles from './createOaModal.scss';

import Modal from '../modal/modal';
import InputField from '../formElements/inputField/inputField';
import { fetchVendorOptions } from './createOaModalRedux/createOaModalActionCreator';

type Props = {
  title: string,
  closeCreateOaModalAction: Function,
  onCreateOaSubmitAction: Function,
  createOaModalState: Object,
  checkOaMobileExistsAction: Function
};

class CreateOaModal extends React.Component<Props> {
  constructor(props: Object) {
    super(props);
    this.state = {
      oaMobileNo: '',
      oaName: '',
      oaToli: '',
      oaVendorCode: '',
      oaVendorName: '',
      vendorOptions: []
    };
    this.setVendorOptions = this.setVendorOptions.bind(this);
  }

  componentDidMount() {
    fetchVendorOptions(this.setVendorOptions);
  }

  // noinspection JSCheckFunctionSignatures
  componentDidUpdate(prevProps: Object): void {
    this.showToast(prevProps, this.props);
    if (
      JSON.stringify(prevProps.createOaModalState) !==
        JSON.stringify(this.props.createOaModalState) &&
      this.props.createOaModalState.oaMobile &&
      this.props.createOaModalState.oaMobile.data &&
      this.props.createOaModalState.oaMobile.data.val
    )
      this.setState({
        oaToli: this.props.createOaModalState.oaMobile.data.val.toli || '',
        oaVendorCode: this.props.createOaModalState.oaMobile.data.val
          .vendorCode,
        oaVendorName: this.props.createOaModalState.oaMobile.data.val.vendorName
      });
  }

  setOaMobile(val: any) {
    this.setState({ oaMobileNo: val });
    // eslint-disable-next-line
    const { checkOaMobileExistsAction } = this.props;
    checkOaMobileExistsAction(val);
  }

  setOaName(val: any) {
    this.setState({ oaName: val });
  }

  setOaToli(val: any) {
    this.setState({ oaToli: val });
  }

  setOaVendor(selectedOption: any) {
    this.setState({
      oaVendorCode: selectedOption && selectedOption.value,
      oaVendorName: selectedOption && selectedOption.vendorName
    });
  }

  setSubmitData() {
    const { createOaModalState } = this.props;
    const {
      oaName,
      oaMobileNo,
      oaToli,
      oaVendorCode,
      oaVendorName
    } = this.state;
    const data = {
      user: {
        name: oaName,
        mobileNo: oaMobileNo,
        toli: oaToli,
        vendorCode: oaVendorCode,
        vendorName: oaVendorName
      },
      isPullFlag: false
    };
    if (
      createOaModalState.oaMobile.data.val &&
      createOaModalState.oaMobile.data.val.id
    ) {
      data.userId = createOaModalState.oaMobile.data.val.id;
      data.isPullFlag = true;
    }
    return data;
  }

  showToast(prevProps, currProps) {
    const { status } = currProps.createOaModalState.data;
    const prevStatus = prevProps.createOaModalState.data.status;
    if (status !== null && prevStatus !== status) {
      if (status === 'success') {
        toastr.success('Success', currProps.createOaModalState.data.val);
        this.closeModal(true);
      } else if (status === 'error' || status === 'exception') {
        toastr.error('Error', currProps.createOaModalState.data.val);
      }
    }
  }

  validateForm() {
    const { createOaModalState } = this.props;
    const { oaMobileNo, oaName } = this.state;
    if (!oaMobileNo.trim()) {
      toastr.error('Invalid Form', 'Please enter OA mobile number');
      return false;
    }
    if (!(oaName || createOaModalState.oaMobile.data.val.name)) {
      toastr.error('Invalid Form', 'Please enter OA name');
      return false;
    }

    return true;
  }

  handleSubmitClick() {
    const { createOaModalState } = this.props;
    const { onCreateOaSubmitAction } = this.props;
    if (createOaModalState.oaMobile.data.isLoading) {
      return;
    }

    if (this.validateForm()) {
      const requestParams = this.setSubmitData();
      onCreateOaSubmitAction(requestParams);
    }
  }

  setVendorOptions(options) {
    this.setState({
      vendorOptions: options
    });
  }

  closeModal(refreshTab: boolean) {
    const { closeCreateOaModalAction, createOaModalState } = this.props;
    createOaModalState.oaMobile.data.val = '';
    this.setState({
      oaMobileNo: '',
      oaName: '',
      oaToli: '',
      oaVendorCode: '',
      oaVendorName: ''
    });
    closeCreateOaModalAction({ refreshTab });
  }

  renderMobileSection() {
    return (
      <div
        className={`${styles.nameSection} l-column j-center name-input-wrapper`}
      >
        <InputField
          label="OA Mobile"
          placeholder="Enter OA Mobile"
          type="text"
          onChange={val => this.setOaMobile(val)}
        />
      </div>
    );
  }

  renderNameSection() {
    const { createOaModalState } = this.props;
    const { oaMobileNo } = this.state;
    const disabled =
      !oaMobileNo ||
      createOaModalState.oaMobile.data.isLoading ||
      createOaModalState.oaMobile.data.status === 'error' ||
      (createOaModalState.oaMobile.data.val &&
        createOaModalState.oaMobile.data.val.id);
    return (
      <div
        className={`${styles.nameSection} l-column j-center name-input-wrapper`}
      >
        <InputField
          label="OA Name"
          placeholder="Enter OA Name"
          type="text"
          value={
            createOaModalState.oaMobile.data.val &&
            createOaModalState.oaMobile.data.val.name
              ? createOaModalState.oaMobile.data.val.name
              : ''
          }
          disabledClass="cc-disable-input"
          disabled={disabled}
          onChange={val => this.setOaName(val)}
        />
      </div>
    );
  }

  renderToliSection() {
    return (
      <div
        className={`${styles.nameSection} l-column j-center name-input-wrapper`}
      >
        <InputField
          label="OA Toli (Optional)"
          placeholder="Enter OA Toli"
          type="text"
          onChange={val => this.setOaToli(val)}
          value={this.state.oaToli}
        />
      </div>
    );
  }

  renderVendorSection() {
    const { oaVendorCode } = this.state;
    return (
      <div
        className={`${styles.nameSection} l-column j-center name-input-wrapper`}
      >
        <div className={`${styles.selectLabel} input-label`}>
          Vendor (Optional)
        </div>
        <Select
          multi={false}
          value={
            this.state.vendorOptions &&
            this.state.vendorOptions.filter(
              option => option.value === oaVendorCode
            )
          }
          onChange={val => this.setOaVendor(val)}
          searchable={false}
          isClearable={true}
          options={this.state.vendorOptions}
        />
      </div>
    );
  }

  renderButtons() {
    return (
      <div className={`${styles.footerSection} l-row j-end a-center `}>
        <div
          className={` ${styles.cancelBtnWrapper} cancel-btn-wrapper l-row j-center a-center`}
          onClick={() => this.closeModal(false)}
        >
          CANCEL
        </div>
        <div
          className={` ${styles.submitBtnWrapper} submit-btn-wrapper l-row j-center a-center `}
          onClick={() => this.handleSubmitClick()}
        >
          SUBMIT
        </div>
      </div>
    );
  }

  render() {
    const { createOaModalState, title } = this.props;
    return (
      <Modal
        showLoader={createOaModalState.isLoading}
        showModal={createOaModalState.showCreateOaModal}
        title={title}
        closeModal={() => {
          this.closeModal(false);
        }}
      >
        <div className={styles.createOaModalWrapper}>
          <div className="create-oa-modal-body">
            {this.renderMobileSection()}
            {this.renderNameSection()}
            {this.renderToliSection()}
            {this.renderVendorSection()}
            {this.renderButtons()}
          </div>
        </div>
      </Modal>
    );
  }
}

export default CreateOaModal;
